import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=28c7b1ca&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports